import React, { useRef, useState } from 'react';

import useClickOutside from '../../../common/hooks/useClickOutside';
import useTranslate from '../../../common/hooks/useTranslate';

import EmailStore from '../../../common/services/config/emailStore';

import { IContactTooltip } from '../types/IContactTooltip';

import './contactTooltip.scss';

const ContactTooltip: React.FC<IContactTooltip> = ({ setTooltip, id }) => {
  const [copySuccess, setCopySuccess] = useState<string>('');

  const { t } = useTranslate();
  const wrapperRef = useRef(null);

  const clickOutsideHandler = () => {
    setTooltip(false);
  };

  const copyToClipBoard = async (copyMe: string) => {
    try {
      await navigator.clipboard.writeText(copyMe);
      setCopySuccess(t('CONTACT_TOOLTIP.SUCCESS_TEXT'));
    } catch (err) {
      setCopySuccess(t('CONTACT_TOOLTIP.FAIL_TEXT'));
    }
  };

  useClickOutside(wrapperRef, clickOutsideHandler, id);

  return (
    <div className='contact-tooltip-wrapper' ref={wrapperRef}>
      <p className='contact-tooltip-header'>{t('CONTACT_TOOLTIP.TEXT1')}</p>
      <p className='contact-tooltip-body'>
        {t('CONTACT_TOOLTIP.TEXT2')} <a className='contact-email-link'>{EmailStore.default_email}</a>
      </p>
      <button className='copy-mail-btn pointer' onClick={() => copyToClipBoard(EmailStore.default_email)}>
        {copySuccess ? copySuccess : t('CONTACT_TOOLTIP.BUTTON_COPY')}
      </button>
    </div>
  );
};

export default ContactTooltip;
